module.exports = __webpack_public_path__ + "static/media/fo.4bd8156d.svg";